import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=c7dfee02&lang=pug&"
import script from "./Component.vue?vue&type=script&lang=js&"
export * from "./Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports